<script lang="ts" setup>
import type { SeoLink } from '~/types/Catalog';

const { links } = defineProps<{ links: SeoLink[] }>();
const expanded = reactive<Record<string, boolean>>({});

const sectionTitles: Record<string, string> = {
  brand: 'Бренды категории',
  category: 'Категории бренда',
  category_brand: 'Категория и бренд',
  related: 'Связанные страницы',
};

const sections = computed(() => {
  const grouped = new Map<string, SeoLink[]>();

  for (const link of links) {
    const key = link.relation ?? 'related';
    grouped.set(key, [...(grouped.get(key) ?? []), link]);
  }

  return [...grouped.entries()].map(([key, sectionLinks]) => ({
    key,
    title: sectionTitles[key],
    links: sectionLinks,
  }));
});
</script>

<template>
  <section
    v-if="links.length"
    class="seo-catalog-page-links"
  >
    <div
      v-for="section in sections"
      :key="section.key"
      class="seo-catalog-page-links__section"
    >
      <h2 class="text-lg">{{ section.title }}</h2>

      <div class="seo-catalog-page-links__items">
        <AppLink
          v-for="link in section.links.slice(0, expanded[section.key] ? undefined : 12)"
          :key="link.id"
          :to="link.uri"
          class="seo-catalog-page-links__link"
        >
          {{ link.title }}
        </AppLink>

        <button
          v-if="section.links.length > 12"
          class="seo-catalog-page-links__show-all"
          @click="expanded[section.key] = !expanded[section.key]"
        >
          {{ expanded[section.key] ? 'Скрыть' : 'Показать все' }}
        </button>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.seo-catalog-page-links {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__section {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__items {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  &__link {
    padding: 4px 8px;
    border-radius: 8px;
    background-color: $white;
    color: $black-80;
    font-size: $text-sm;
    transition: all 0.2s;

    @apply shadow-sm;

    &:hover {
      background-color: $black-10;
      color: $black;
    }
  }

  &__show-all {
    display: inline-flex;
    align-items: center;
    color: $black-60;
    font-size: $text-sm;
    transition: all 0.2s;

    &:hover {
      color: $black-40;
      text-decoration: underline;
    }
  }
}
</style>
